<div id="ap-wrapper">
  <div id="ap-canvas">
    <div id="ap-top-bar">
      <div class="left">
        <span id="ap-welcome-text">Welcome {{userName}}</span>
      </div>

      <div class="right">
        <a href="https://www.airproducts.com" id="ap-my-company-website">airproducts.com</a>
      </div>
    </div>


    <div class="main-content">
      <app-side-nav-outer-toolbar></app-side-nav-outer-toolbar>
      <app-notification></app-notification>
    </div>
   </div>
  </div>
